import { AxiosInstance } from "axios";
import useAuthenticatedFetch from "./useAuthenticatedFetch";

export interface AlarmHandling {
  id: number;
  name: string;
}

const fetchAlarmHandlings = (objectId: string) => {
  const { data, isLoading, isError } = useAuthenticatedFetch<AlarmHandling[]>(
    `/api/v2/users/${objectId}/alarmhandlings`,
  );

  return { data, isLoading, isError };
};

const getAlarmHandlings = (
  authenticatedRequest: AxiosInstance,
  objectId: string,
) =>
  authenticatedRequest.get<AlarmHandling[]>(
    `/api/v2/users/${objectId}/alarmhandlings`,
  );

const saveTemporaryHandling = (
  authenticatedRequest: AxiosInstance,
  objectId: string,
  data: {
    id?: number;
    end?: Date;
  },
) =>
  authenticatedRequest.post(
    `/api/v2/users/${objectId}/temporaryalarmhandling`,
    JSON.stringify(data),
    { headers: { "Content-Type": "application/json" } },
  );

export { fetchAlarmHandlings, getAlarmHandlings, saveTemporaryHandling };
